export default "__VITE_ASSET__7bb6a002__"